<template>
    <div class="lang">
        <div class="greeting">
            <div class="greeting__inner">
                <div class="greeting__bg"><img src="/resource/img/about-bg02.png" alt=""></div>
                <div class="greeting__tit pc-none">
                    <div class="greeting__tit-inner item1">
                        <div>
                            Сайн байцгаана уу? <br>
                            Велнес Эрүүл мэндийг дэмжих төвийн цахим хуудсанд тавтай морилно уу.
                        </div>
                    </div>
                </div>
                <div class="greeting__img">
                    <div class="greeting__img-inner">
                        <img src="/resource/img/img_hos01_01.jpg" alt="">
                    </div>
                    <div class="greeting__img-bg"></div>
                </div>
                <div class="greeting__text">
                    <div class="greeting__tit mo-none">
                        <div class="greeting__tit-inner item1">
                            <div>
                                Сайн байцгаана уу? <br>
                                Велнес Эрүүл мэндийг дэмжих төвийн цахим хуудсанд тавтай морилно уу.
                            </div>
                        </div>
                    </div>
                    <div class="desc">
                        <p>
                            <b>Эрүүл мэнд гэж юу билээ.</b> <br>
                            Ханатлаа унтаад толгой сэргэг өглөөг угтан, юунд ч түүртэлгүй чөлөөтэй, эрч хүч дүүрэн алхсаар хүссэн газраа очоод, хүссэн зүйлдээ хамаг анхааралдаа хандуулан хийж гүйцэтгээд, бусад хүмүүстэй сэтгэл санаагаа чөлөөтэй хуваалцаж зэрэгцэн оршихыг бие болон сэтгэл, нийгмийн харилцааны хувьд эрүүл байна гэдэг.
                        </p>
                        <p>
                            <b>Аз жаргал гэж юу билээ.</b><br>
                            Хүүхдүүдийн хөгжилтэй инээд, гэр бүлээрээ эв найртай тойрон суух хоолны ширээ, хөлсөө дуслуулан байж уулын оргилд гарах тэр бахархалт мөч, бороотой өдөр кафед суугаад кофены үнэрт уусан ном унших тэр үе, үр хойчийнхоо төлөө үүрийн цагаан гэгээнээр мөргөлд явах өвөө эмээ нарын цуцашгүй алхаа. Энэ бүгд бол та бидний амсаж үзэхийг, он удаан жил үргэлжлүүлэхийг хүсдэг аз жаргалтай дүр зураг.
                        </p>
                        <p>
                            <b>Энэхүү аз жаргалтай мөчүүдийг үзэхийн тулд заавал эрүүл энх байх хэрэгтэй</b><br>
                            Велнес(Wellness) гэдэг үг нь вел-биин(well-being) болон фитнес(fitness) гэсэн үгсийн утгыг агуулж байдаг бөгөөд бие, сэтгэл, нийгмийн харилцааны хувьд эрүүл байж аз жаргалтайгаар нас нэмж, нэр төртэйгөөр амьдарна гэсэн үг юм. <br>
                            Өвчин тусахаас өмнө урьдчилан сэргийлэх нь хамгийн чухал бөгөөд хэрэв өвдсөн бол өвчнөө эрт үед нь оношилж эмчлэх нь чухал юм. <br>
                            Хүн төрөлхтөн 100 насалдаг болж буй өнөө үед эрүүл мэндийн тогтмол үзлэг хийлгэж, эрүүл мэндийн хувьд ямар асуудалтай байгаагаа тодруулж, бас дээр нь өвчнөөс урьдчилан сэргийлж, нарийн мэргэжлийн эмч мэргэжилтэн, тоног төхөөрөмжийн тусламжтайгаар өвчин эмгэгийг эхнийх нь шатанд оношлон илрүүлж эмчилж чадвал жинхэнэ “велнес(эрүүл бөгөөд сайн сайхан)” амьдралаар амьдарч чадна.
                        </p>
                        <p>
                            <b>Үргэлж шинэ! Үргэлж танд ойр! Илүү үнэн зөв!</b><br>
                            Эрүүл хүн та эрүүл мэндээ сахин хамгаалж, энх саруул аз жаргалтай амьдрахад И-Хуа их сургуулийн Сөүл салбар эмнэлгийн Велнес Эрүүл мэндийг дэмжих төв туслах болно.
                        </p>
    
    
                        <div class="name">
                            <p>И-Хуа их сургуулийн Сөүл салбар эмнэлгийн Велнес Эрүүл мэндийг дэмжих төв</p>
                            <span>Сун Хье Гён, Head of Center</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { gsap, Power1 } from "gsap";
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger); // 추가된 부분
    export default {
        methods: {
            gsapAbout() {
                gsap.from(".greeting__img img", {
                    height: 0,
                    duration: 1,
                    delay: .5,
                });
                gsap.from(".greeting__img img", {
                    scale: 1.2,
                    duration: 4,
                    delay: 1.4,
                });
                gsap.from(".greeting__img-bg", {
                    opacity: 0,
                    x: 0,
                    y: 0,
                    duration: 1,
                    delay: 1.5,
                });
                gsap.from(".greeting__tit .item2 em span", {
                    width: 0,
                    duration: 1.5,
                    delay: 2,
                    ease: Power1.easeInOut,
                    // onComplete: () => {
                    //     gsap.to(".greeting__tit .item2 em span", {
                    //         backgroundColor: 'var(--aorta-P10)',
                    //         duration: 1.5
                    //     });
                    // }
                });
                gsap.from(".item1 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".item2 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".desc", {
                    opacity: 0,
                    y: 30,
                    duration: 1,
                    delay: 2.8,
                });
                gsap.from(".greeting__bg", {
                    opacity: 0,
                    duration: 3,
                    delay: 1,
                });

            }
        },
        mounted() {
            if (window.innerWidth >= 1025) {
                this.gsapAbout();
            }
        },
    }

</script>
<style>

</style>